import tourConfig from '../common/tour/config';

const tourSteps = (language) => {
	let tourOptions = tourConfig.getOptions(language);
	tourOptions.steps = [
		{
			element: '.main-container',
			intro: language.tour.summaryPvtLastResultsTour.generalView,
			position: 'right'
		},
		{
			element: '.filter-box',
			intro: language.tour.summaryPvtLastResultsTour.topFilters,
			position: 'right'
		},
		{
			element: '.th-name',
			intro: language.tour.summaryPvtLastResultsTour.name,
			position: 'right'
		},
		{
			element: '.th-category',
			intro: language.tour.summaryPvtLastResultsTour.carrier,
			position: 'right'
		},
		{
			element: '.th-group',
			intro: language.tour.summaryPvtLastResultsTour.workingShiftGroup,
			position: 'left'
		},
		{
			element: '.th-score',
			intro: language.tour.summaryPvtLastResultsTour.scoreFFD,
			position: 'left'
		},
		{
			element: '.th-date',
			intro: language.tour.summaryPvtLastResultsTour.calcDate,
			position: 'left'
		},
		{
			element: '.th-info',
			intro: language.tour.summaryPvtLastResultsTour.ffd ,
			position: 'left'
		},
		{
			element: '.excel-buttons',
			intro: language.tour.summaryPvtLastResultsTour.excelButton,
			position: 'left'
		}
	];

	return tourOptions;
};

export default tourSteps;


// WEBPACK FOOTER //
// ./source/client/components/last_data_ffd_pvt/tourSteps.js